import React from 'react'

import FormManager from "../../../gd-form/common/form-manager"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FormError from "../../../gd-form/common/form-error/form-error"
import FieldFormElement from "../../../fields3/render/form-elemnent"

type Props = {
    form: FormManager
}

export default function CustomFieldName(props: Props) {

    return (
        <FormRowFlex field={gd.fields.customFields.name}>
            <div className="flex-column-left-top">
                <FieldFormElement className = "w-300"
                                  field     = {gd.fields.customFields.name}
                                  form      = {props.form}/>
                <FormError form = {props.form}
                           name = {gd.fields.customFields.name.fieldId} />
            </div>
        </FormRowFlex>
    )
}